<script setup>
const props = defineProps({
	hash: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<router-link class="tag inline-block z-20 h-10 cursor-pointer border-2 border-crowns-castle-shadow bg-crowns-grey px-3 pb-7 pt-3 font-semibold leading-none text-crowns-off-white shadow-md transition-transform duration-300" :to="{ name: 'services', hash: `#${hash}` }">
		<slot />
	</router-link>
</template>
